import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "13",
  fill: "none",
  viewBox: "0 0 17 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.345 0a1.57 1.57 0 0 1 1.566 1.484 1 1 0 0 1 .006.086v9.18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V1.57q0-.04.003-.077A1.57 1.57 0 0 1 1.57 0zM9.603 7.492a2 2 0 0 1-2.289 0L1.5 3.437v7.313a.5.5 0 0 0 .5.5h12.917a.5.5 0 0 0 .5-.5V3.437zM1.57 1.5a.071.071 0 0 0-.04.13l6.64 4.632c.173.12.401.12.573 0l6.642-4.632a.071.071 0 0 0-.041-.13z"
    }, null, -1)
  ]))]))
}
export default { render: render }